<template>
    <div>
        <input type="text" placeholder="Click to Add a New Comment" class="form-control" v-on:click="showForm = true;" v-if="!showForm" />

        <div v-if="showForm">
            <div class="mb-2">
                <b-form-textarea ref="commentFormTextarea" v-model="comment.comment_details" placeholder="Enter Comments" rows="6" :class="{'is-invalid': errors.comment_details}" autofocus></b-form-textarea>
                <div v-if="errors.comment_details" class="text-danger">
                    <span v-for="(err, i) in errors.comment_details"><template v-if="i > 0">. </template>{{ err }}</span>
                </div>
            </div>

            <button class="btn btn-default" v-on:click="resetCommentForm()"  :disabled="saving">Cancel</button>
            <button class="btn btn-success" v-on:click="saveComment()" :disabled="saving">
                <template v-if="saving">
                    <i class="fas fa-spinner fa-spin"></i>
                    <template v-if="comment.id">Updating</template>
                    <template v-else>Adding</template>
                </template>
                <template v-else>
                    <template v-if="comment.id">Update</template>
                    <template v-else>Add</template>
                </template>
                Comment
            </button>
        </div>
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {
        props: {

            assetType: {
                type: String,
                required: true,
            },

            assetId: {
                type: Number,
                required: true,
            },
        },

        data() {
            return {
                saving: false,
                showForm: false,
                comment: {},
                errors: {},
            }
        },

        computed: {

        },

        watch: {

        },

        methods: {
            //Create
            newComment(){
                return {
                    comment_details: '',
                };
            },

            //Send it
            saveComment(){
                //Check for post/patch
                if(this.comment.id)
                {
                    return this.updateComment();
                }

                //Create the comment
                return this.createComment();
            },

            //Send it
            createComment(){
                //Saving
                this.saving = true;

                //Send it
                this.$http.post('/comments/' + this.assetType + '/' + this.assetId, this.comment)
                    .then(response => {
                        //Emit the data
                        this.$emit('commentCreated', response.data);

                        //Alert the user
                        this.$toastr.s('Comment Added');

                        //Reset the form
                        this.resetCommentForm();
                    })
                    .catch(error => {
                        if(!error.response || !error.response.status)
                        {
                            //Alert the user
                            this.$toastr.e(error, 'Something Went Wrong');

                            //Log for debugging
                            console.log(error);

                            //Stop Here
                            return;
                        }
                        //Check for a status
                        switch(error.response.status)
                        {
                            case 418:
                                //Alert the user
                                this.$toastr.e(error.response.data);
                                break;

                            case 422:
                                //Set the errosr
                                this.errors = error.response.data.errors;
                                break;

                            case 500:
                                //Alert the user
                                this.$toastr.e(error.response.data, 'Something Went Wrong');
                                break;
                        }
                    })
                    .then(() => {
                        //Reset
                        this.saving = false;
                    });
            },

            updateComment(){
                //Saving
                this.saving = true;

                //Send it
                this.$http.patch('/comments/' + this.comment.id, this.comment)
                    .then(response => {
                        //Emit the data
                        this.$emit('commentUpdated', this.comment);

                        //Alert the user
                        this.$toastr.s('Comment Updated');

                        //Reset the form
                        this.resetCommentForm();
                    })
                    .catch(error => {
                        if(!error.response || !error.response.status)
                        {
                            //Alert the user
                            this.$toastr.e(error, 'Something Went Wrong');

                            //Log for debugging
                            console.log(error);

                            //Stop Here
                            return;
                        }
                        //Check for a status
                        switch(error.response.status)
                        {
                            case 418:
                                //Alert the user
                                this.$toastr.e(error.response.data);
                                break;

                            case 422:
                                //Set the errosr
                                this.errors = error.response.data.errors;
                                break;

                            case 500:
                                //Alert the user
                                this.$toastr.e(error.response.data, 'Something Went Wrong');
                                break;
                        }
                    })
                    .then(() => {
                        //Reset
                        this.saving = false;
                    });
            },

            editComment(comment){
                //Send it
                this.comment = comment;

                //Set the flag
                this.showForm = true;
            },

            resetCommentForm(){
                //Set flag
                this.showForm = false;

                //Reset
                this.comment = this.newComment();
            },
        },

        mounted() {
            //Send it
            this.comment = this.newComment();
        }
    }
</script>
